module.exports = __webpack_public_path__ + "img/bottom_bg.69d36982.png";